import type { AxiosResponse } from 'axios';
import ApiService from '@/api/api_service';
import type { ApiArguments } from '@/api/api_service';
import type { AiFeedbackResult } from '@/api/openapi';
import { AiFeedbackResultApi } from '@/api/openapi';

export class AiFeedbackResultApiService extends ApiService {
  api = new AiFeedbackResultApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async remindAiFeedbackResult(aiFeedbackResult: AiFeedbackResult, { options }: ApiArguments<void> = {}): Promise<AxiosResponse<void>> {
    return this.api.postAiFeedbackResultRemind({
      aiFeedbackResultId: aiFeedbackResult.id,
    }, options);
  }

  async cancelReminderAiFeedbackResult(aiFeedbackResult: AiFeedbackResult, { options }: ApiArguments<void> = {}): Promise<AxiosResponse<void>> {
    return this.api.postAiFeedbackResultCancelReminder({
      aiFeedbackResultId: aiFeedbackResult.id,
    }, options);
  }

  async confirmAiFeedbackResult(aiFeedbackResult: AiFeedbackResult, { options }: ApiArguments<void> = {}): Promise<AxiosResponse<void>> {
    return this.api.postAiFeedbackResultConfirm({
      aiFeedbackResultId: aiFeedbackResult.id,
    }, options);
  }
}
